(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/store/assets/javascripts/reducers/video-analyses-slice.js') >= 0) return;  svs.modules.push('/components/tipsen/store/assets/javascripts/reducers/video-analyses-slice.js');
"use strict";


const _RTK = RTK,
  createSlice = _RTK.createSlice,
  createAsyncThunk = _RTK.createAsyncThunk;

const fetchVideoAnalyses = createAsyncThunk('videoAnalyses/fetchVideoAnalyses', async (_ref, _ref2) => {
  let drawNumber = _ref.drawNumber,
    categories = _ref.categories;
  let rejectWithValue = _ref2.rejectWithValue;
  try {
    const params = new URLSearchParams({
      drawNumber: drawNumber.toString()
    });
    if (categories) {
      params.append('categories', categories);
    }
    const response = await fetch("/pool-betting-api/v1/video-analyses?".concat(params.toString()));
    if (!response.ok) {
      throw new Error("Error fetching video analyses. Status: ".concat(response.status));
    }
    const data = await response.json();
    return data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});
const videoAnalysesSlice = createSlice({
  name: 'videoAnalyses',
  initialState: {
    videos: {},
    loading: false,
    error: null,
    lastFetched: null,
    drawNumber: null,
    currentVideo: null,
    playbackState: {
      id: null,
      isPlaying: false,
      isReady: false,
      currentPosition: 0,
      duration: 0,
      progress: 0 
    }
  },
  reducers: {
    clearVideoAnalyses: state => {
      state.videos = {};
      state.error = null;
      state.lastFetched = null;
      state.drawNumber = null;
      state.currentVideo = null;
      state.playbackState = {
        id: null,
        isPlaying: false,
        isReady: false,
        currentPosition: 0,
        duration: 0,
        progress: 0
      };
    },
    clearError: state => {
      state.error = null;
    },
    setCurrentVideo: (state, action) => {
      state.currentVideo = action.payload;
      state.playbackState = {
        id: null,
        isPlaying: false,
        isReady: false,
        currentPosition: 0,
        duration: 0,
        progress: 0
      };
    },
    clearCurrentVideo: state => {
      state.currentVideo = null;
      state.playbackState = {
        id: null,
        isPlaying: false,
        isReady: false,
        currentPosition: 0,
        duration: 0,
        progress: 0
      };
    },
    updatePlaybackState: (state, action) => {
      const _action$payload = action.payload,
        id = _action$payload.id,
        isPlaying = _action$payload.isPlaying,
        isReady = _action$payload.isReady,
        currentPosition = _action$payload.currentPosition,
        duration = _action$payload.duration;
      state.playbackState.id = id !== undefined ? id : state.playbackState.id;
      state.playbackState.isPlaying = isPlaying !== undefined ? isPlaying : state.playbackState.isPlaying;
      state.playbackState.isReady = isReady !== undefined ? isReady : state.playbackState.isReady;
      const calculatedCurrentPosition = currentPosition !== undefined ? currentPosition : state.playbackState.currentPosition;
      state.playbackState.currentPosition = Math.floor(calculatedCurrentPosition);
      const calculatedDuration = duration !== undefined ? duration : state.playbackState.duration;
      state.playbackState.duration = Math.floor(calculatedDuration);

      if (state.playbackState.duration > 0) {
        const calculatedProgress = state.playbackState.currentPosition / state.playbackState.duration * 100;
        state.playbackState.progress = Math.floor(calculatedProgress);
      } else {
        state.playbackState.progress = 0;
      }
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchVideoAnalyses.pending, (state, action) => {
      state.loading = true;
      state.error = null;
      state.drawNumber = action.meta.arg.drawNumber;
    }).addCase(fetchVideoAnalyses.fulfilled, (state, action) => {
      state.loading = false;
      state.videos = action.payload.videos || {};
      state.lastFetched = new Date().toISOString();
      state.error = null;
    }).addCase(fetchVideoAnalyses.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || 'Failed to fetch video analyses';
    });
  }
});
const selectVideoAnalyses = state => {
  var _state$VideoAnalyses;
  return ((_state$VideoAnalyses = state.VideoAnalyses) === null || _state$VideoAnalyses === void 0 ? void 0 : _state$VideoAnalyses.videos) || {};
};
const selectVideoAnalysesLoading = state => {
  var _state$VideoAnalyses2;
  return ((_state$VideoAnalyses2 = state.VideoAnalyses) === null || _state$VideoAnalyses2 === void 0 ? void 0 : _state$VideoAnalyses2.loading) || false;
};
const selectVideoAnalysesError = state => {
  var _state$VideoAnalyses3;
  return ((_state$VideoAnalyses3 = state.VideoAnalyses) === null || _state$VideoAnalyses3 === void 0 ? void 0 : _state$VideoAnalyses3.error) || null;
};
const selectVideoAnalysesDrawNumber = state => {
  var _state$VideoAnalyses4;
  return ((_state$VideoAnalyses4 = state.VideoAnalyses) === null || _state$VideoAnalyses4 === void 0 ? void 0 : _state$VideoAnalyses4.drawNumber) || null;
};
const selectVideoAnalysesLastFetched = state => {
  var _state$VideoAnalyses5;
  return ((_state$VideoAnalyses5 = state.VideoAnalyses) === null || _state$VideoAnalyses5 === void 0 ? void 0 : _state$VideoAnalyses5.lastFetched) || null;
};
const selectDrawVideo = state => {
  var _state$VideoAnalyses6;
  return ((_state$VideoAnalyses6 = state.VideoAnalyses) === null || _state$VideoAnalyses6 === void 0 || (_state$VideoAnalyses6 = _state$VideoAnalyses6.videos) === null || _state$VideoAnalyses6 === void 0 ? void 0 : _state$VideoAnalyses6.draw) || null;
};
const selectMatchVideo = (state, matchNumber) => {
  var _state$VideoAnalyses7;
  return ((_state$VideoAnalyses7 = state.VideoAnalyses) === null || _state$VideoAnalyses7 === void 0 || (_state$VideoAnalyses7 = _state$VideoAnalyses7.videos) === null || _state$VideoAnalyses7 === void 0 ? void 0 : _state$VideoAnalyses7["match".concat(matchNumber)]) || null;
};
const selectAllMatchVideos = state => {
  var _state$VideoAnalyses8;
  const videos = ((_state$VideoAnalyses8 = state.VideoAnalyses) === null || _state$VideoAnalyses8 === void 0 ? void 0 : _state$VideoAnalyses8.videos) || {};
  const matchVideos = {};
  Object.keys(videos).forEach(key => {
    if (key.startsWith('match')) {
      matchVideos[key] = videos[key];
    }
  });
  return matchVideos;
};
const selectHasDrawVideo = state => {
  var _state$VideoAnalyses9;
  return Boolean((_state$VideoAnalyses9 = state.VideoAnalyses) === null || _state$VideoAnalyses9 === void 0 || (_state$VideoAnalyses9 = _state$VideoAnalyses9.videos) === null || _state$VideoAnalyses9 === void 0 ? void 0 : _state$VideoAnalyses9.draw);
};
const selectHasMatchVideos = state => {
  var _state$VideoAnalyses0;
  const videos = ((_state$VideoAnalyses0 = state.VideoAnalyses) === null || _state$VideoAnalyses0 === void 0 ? void 0 : _state$VideoAnalyses0.videos) || {};
  return Object.keys(videos).some(key => key.startsWith('match'));
};
const selectHasAnyVideos = state => {
  var _state$VideoAnalyses1;
  const videos = ((_state$VideoAnalyses1 = state.VideoAnalyses) === null || _state$VideoAnalyses1 === void 0 ? void 0 : _state$VideoAnalyses1.videos) || {};
  return Object.keys(videos).length > 0;
};
const selectCurrentVideo = state => {
  var _state$VideoAnalyses10;
  return ((_state$VideoAnalyses10 = state.VideoAnalyses) === null || _state$VideoAnalyses10 === void 0 ? void 0 : _state$VideoAnalyses10.currentVideo) || null;
};
const selectIsVideoPlaying = state => {
  var _state$VideoAnalyses11;
  return Boolean((_state$VideoAnalyses11 = state.VideoAnalyses) === null || _state$VideoAnalyses11 === void 0 ? void 0 : _state$VideoAnalyses11.currentVideo);
};
const selectPlaybackState = state => {
  var _state$VideoAnalyses12;
  return ((_state$VideoAnalyses12 = state.VideoAnalyses) === null || _state$VideoAnalyses12 === void 0 ? void 0 : _state$VideoAnalyses12.playbackState) || {
    id: null,
    isPlaying: false,
    isReady: false,
    currentPosition: 0,
    duration: 0,
    progress: 0
  };
};
const selectIsPlaying = state => {
  var _state$VideoAnalyses13;
  return ((_state$VideoAnalyses13 = state.VideoAnalyses) === null || _state$VideoAnalyses13 === void 0 || (_state$VideoAnalyses13 = _state$VideoAnalyses13.playbackState) === null || _state$VideoAnalyses13 === void 0 ? void 0 : _state$VideoAnalyses13.isPlaying) || false;
};
const selectIsReady = state => {
  var _state$VideoAnalyses14;
  return ((_state$VideoAnalyses14 = state.VideoAnalyses) === null || _state$VideoAnalyses14 === void 0 || (_state$VideoAnalyses14 = _state$VideoAnalyses14.playbackState) === null || _state$VideoAnalyses14 === void 0 ? void 0 : _state$VideoAnalyses14.isReady) || false;
};
const selectCurrentPosition = state => {
  var _state$VideoAnalyses15;
  return ((_state$VideoAnalyses15 = state.VideoAnalyses) === null || _state$VideoAnalyses15 === void 0 || (_state$VideoAnalyses15 = _state$VideoAnalyses15.playbackState) === null || _state$VideoAnalyses15 === void 0 ? void 0 : _state$VideoAnalyses15.currentPosition) || 0;
};
const selectDuration = state => {
  var _state$VideoAnalyses16;
  return ((_state$VideoAnalyses16 = state.VideoAnalyses) === null || _state$VideoAnalyses16 === void 0 || (_state$VideoAnalyses16 = _state$VideoAnalyses16.playbackState) === null || _state$VideoAnalyses16 === void 0 ? void 0 : _state$VideoAnalyses16.duration) || 0;
};
const selectProgress = state => {
  var _state$VideoAnalyses17;
  return ((_state$VideoAnalyses17 = state.VideoAnalyses) === null || _state$VideoAnalyses17 === void 0 || (_state$VideoAnalyses17 = _state$VideoAnalyses17.playbackState) === null || _state$VideoAnalyses17 === void 0 ? void 0 : _state$VideoAnalyses17.progress) || 0;
};
const _videoAnalysesSlice$a = videoAnalysesSlice.actions,
  clearVideoAnalyses = _videoAnalysesSlice$a.clearVideoAnalyses,
  clearError = _videoAnalysesSlice$a.clearError,
  setCurrentVideo = _videoAnalysesSlice$a.setCurrentVideo,
  clearCurrentVideo = _videoAnalysesSlice$a.clearCurrentVideo,
  updatePlaybackState = _videoAnalysesSlice$a.updatePlaybackState;
setGlobal('svs.components.tipsen.store.reducers.videoAnalysesSlice', {
  reducer: videoAnalysesSlice.reducer,
  actions: {
    fetchVideoAnalyses,
    clearVideoAnalyses,
    clearError,
    setCurrentVideo,
    clearCurrentVideo,
    updatePlaybackState
  },
  selectors: {
    selectVideoAnalyses,
    selectVideoAnalysesLoading,
    selectVideoAnalysesError,
    selectVideoAnalysesDrawNumber,
    selectVideoAnalysesLastFetched,
    selectDrawVideo,
    selectMatchVideo,
    selectAllMatchVideos,
    selectHasDrawVideo,
    selectHasMatchVideos,
    selectHasAnyVideos,
    selectCurrentVideo,
    selectIsVideoPlaying,
    selectPlaybackState,
    selectIsPlaying,
    selectIsReady,
    selectCurrentPosition,
    selectDuration,
    selectProgress
  }
});

 })(window);